import {getToken} from "@/helpers/auth/auth-helper";


export async function uploadShape(data) {

    // const url = 'https://beta.kaartviewer.nl/admin/rest/printapi/bookmark/118'
    const url = window.kaartViewerUrl + '/admin/v2/kaartviewerapi/bookmark/' + window.websiteName +  '/geo/uploadfile'

    return new Promise(function (resolve, reject) {
        var Http = new XMLHttpRequest();
        Http.open('POST', url);

        let token = getToken()
        if(token !== undefined) {
            Http.setRequestHeader("Authorization", token);
        }

        Http.onload = function () {

            if (Http.status === 200) {
                resolve(JSON.parse(Http.response));
            }
        }

        Http.send(data);
    })
}
